import React, { useState } from "react";

import { OverlayTrigger, Popover } from "react-bootstrap";
import { InfoCircleFill } from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import {
    createTrackersApi,
    isInactiveSignalSubscription,
} from "helpers/getStarted/createBussinesApi";

import { loginTrue } from "../redux/slices/isLogin/isLogin.slice";
import SwalAlertComp from "./SwalAlert";

const SourcesModal = (props) => {
    const [searchParams] = useSearchParams();
    const [createSource, setCreateSource] = useState("");
    const [cpi, setCpi] = useState("cpi");
    const [genericDomain, setGenericDomain] = useState("ssevt.com");
    const [customCpi, setCustomCpi] = useState("cpi");
    const [customDomain, setCustomDomain] = useState("");
    const [createErrors, setCreateErrors] = useState("");
    const [createErrorsCpi, setCreateErrorsCpi] = useState("");
    const language = useSelector((state) => state.languagesState.languages);
    const [useCustomDomain, setUseCustomDomain] = useState(false);
    const [useGenericDomain, setUseGenericDomain] = useState(true);
    const [fbState, setFbState] = useState(searchParams.get("state"));
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const urlPatternValidation = (URL) => {
        let result = URL.replace(/^https?:\/\//, "");
        let finalResult = result.replace("www.", "");
        return finalResult;
    };

    const handleChange = (e) => {
        setCreateSource(e.target.value);
        let value = e.target.value;
        let isTrueVal = value && urlPatternValidation(value);
        setCustomDomain(isTrueVal);
        if (createErrors !== "") {
            setCreateErrors("");
        }
    };
    const handleCreateSource = async () => {
        if (useCustomDomain) {
            if (customCpi === "") {
                setCreateErrorsCpi(
                    language?.tracker_wizard?.cannot_be_blank ??
                        "Cannot be blank!",
                );
            } else if (customDomain === "") {
                setCreateErrors(
                    language?.delete_swal_modal
                        ?.website_domain_cannot_be_blank ??
                        "Website Domain cannot be blank!",
                );
            } else if (createSource === "") {
                setCreateErrors(
                    language?.delete_swal_modal
                        ?.website_domain_cannot_be_blank ??
                        "Website Domain cannot be blank!",
                );
            } else {
                await makeRequest();
            }
        } else if (useGenericDomain && createSource !== "") {
            await makeRequest();
        } else {
            if (useGenericDomain && createSource === "") {
                setCreateErrors(
                    language?.delete_swal_modal
                        ?.website_domain_cannot_be_blank ??
                        "Website Domain cannot be blank!",
                );
            }
            return;
        }
    };

    const showTrackerError = (result) => {
        if (isInactiveSignalSubscription(result)) {
            props.onInactiveSubscription?.();
            return;
        }
        SwalAlertComp({
            title: language?.delete_swal_modal?.failed ?? "Failed",
            message: result.message || "Unknown error occurred.",
            icon: "error",
        });
    };

    const makeRequest = async () => {
        let form = {
            be_id: props.data.be_id,
            be_token: props.data.be_token,
            access_token: props.token,
            business_vertical: props.data.business_vertical,
            business_name: props.data.business_name,
            currency: props.data.currency,
        };

        try {
            (function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            })(document, "script", "facebook-jssdk");
        } catch (error) {}

        let be_extra = {
            setup: {
                external_business_id: form.be_id,
                timezone: "UTC",
                currency: form.currency,
                business_vertical: form.business_vertical,
            },
            business_config: {
                business: {
                    name: form.business_name,
                },
            },
            repeat: false,
        };
        let fb_scope =
            "email,manage_business_extension,ads_management,pages_read_engagement,ads_read,business_management"; //,

        be_extra.setup.channel = "SIGNALS";

        let trackerCreateForm;
        if (useGenericDomain === true) {
            trackerCreateForm = {
                source: {
                    domain: createSource,
                    subdomain: `${cpi}.${genericDomain}`,
                    is_generic: 1,
                },
                business_slug: props.data.be_id,
                be_token: props.data.be_token,
                is_generic: 1,
            };
        } else if (useCustomDomain === true) {
            trackerCreateForm = {
                source: {
                    domain: createSource,
                    subdomain: `${customCpi}.${customDomain}`,
                    is_generic: 0,
                },
                business_slug: props.data.be_id,
                be_token: props.data.be_token,
                is_generic: 0,
            };
        } else {
            trackerCreateForm = {
                source: { domain: createSource, subdomain: cpi },
                business_slug: props.data.be_id,
                be_token: props.data.be_token,
                is_generic: "true",
            };
        }

        if (fbState) {
            setIsSubmitting(true);
            try {
                let state = JSON.parse(decodeURIComponent(fbState));

                trackerCreateForm.access_token = props.loginStatusAccesToken;

                let result = await createTrackersApi(trackerCreateForm);

                if (result.status) {
                    if (state.redirect_uri) {
                        window.location.href =
                            state.redirect_uri +
                            "&extras=" +
                            encodeURIComponent(JSON.stringify(be_extra));
                    }
                } else {
                    showTrackerError(result);
                }
            } catch (error) {}
            finally {
                setIsSubmitting(false);
            }
        } else {
            try {
                const loginCallback = (responseFB) => {
                    const asyncCallback = async () => {
                        if (responseFB.authResponse) {
                            setIsSubmitting(true);
                            try {
                                let login_access_token =
                                    responseFB.authResponse.accessToken;
                                trackerCreateForm.access_token =
                                    login_access_token;
                                let result =
                                    await createTrackersApi(trackerCreateForm);
                                if (isInactiveSignalSubscription(result)) {
                                    props.onInactiveSubscription?.();
                                    return;
                                }
                                if (result.status) {
                                    try {
                                        setTimeout(() => {
                                            window.FB.api(
                                                `fbe_business/fbe_installs?fbe_external_business_id=${trackerCreateForm.business_slug}`,
                                                (response) => {
                                                    try {
                                                        if (
                                                            response.data &&
                                                            response.data
                                                                .length > 0
                                                        ) {
                                                            window.localStorage.setItem(
                                                                "token",
                                                                result.data
                                                                    ?.auth_token ||
                                                                    "",
                                                            );
                                                            dispatch(
                                                                loginTrue(),
                                                            );
                                                            navigate(
                                                                `/tracker/${result.data?.tracker_id}`,
                                                            );
                                                        } else {
                                                            alert(
                                                                "Error. No Pixel found! User cancelled login or did not fully authorize.",
                                                            );
                                                        }
                                                    } catch (error) {}
                                                },
                                            );
                                        }, 5000);
                                    } catch (error) {}
                                } else {
                                    showTrackerError(result);
                                }
                            } catch (error) {
                                console.error(
                                    "Error during FB login or API calls:",
                                    error,
                                );
                                SwalAlertComp({
                                    title: "Error",
                                    message:
                                        error.message ||
                                        "An unexpected error occurred.",
                                    icon: "error",
                                });
                            } finally {
                                setIsSubmitting(false);
                            }
                        } else {
                            alert(
                                language?.delete_swal_modal
                                    ?.error_login_did_not_authorize ??
                                    "Error. User cancelled login or did not fully authorize.",
                            );
                        }
                    };
                    asyncCallback();
                };
                window.FB.login(loginCallback, {
                    scope: fb_scope,
                    extras: be_extra,
                });
            } catch (error) {}
        }
    };

    const handleCpi = (event) => {
        setCustomCpi(event.target.value);
        if (createErrorsCpi !== "") {
            setCreateErrorsCpi("");
        }
    };

    const handleSubdomain = (event) => {
        setCustomDomain(event.target.value);
        if (createErrors !== "") {
            setCreateErrors("");
        }
    };

    const handleGenericChange = () => {
        setUseGenericDomain(true);
        setUseCustomDomain(false);
    };
    const handleCustomChange = () => {
        setUseGenericDomain(false);
        setUseCustomDomain(true);
    };
    const CustomSubdomainPopover = (
        <Popover id="popover-basic">
            <Popover.Body>
                <div>
                    {language?.welcomepage
                        ?.you_currently_creating_generic_domain ??
                        "You are currently creating a generic domain name. We recommended to use your own subdomain for integration."}
                </div>
            </Popover.Body>
        </Popover>
    );
    return (
        <div>
            <Form>
                <Form.Group
                    className="mb-3 row"
                    controlId="exampleForm.ControlInput1"
                >
                    <Form.Label>
                        {language?.source_modal?.website_domain ??
                            "Website Domain"}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="https://example.com"
                        onChange={handleChange}
                        isInvalid={!!createErrors}
                    />
                    <Form.Control.Feedback type="invalid">
                        {createErrors}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlRadio">
                    <div key="radio-buttons">
                        <div className="row">
                            <Form.Check
                                inline
                                type="radio"
                                label={
                                    language?.tracker_wizard
                                        ?.use_generic_domain ??
                                    "Use Generic Domain"
                                }
                                name="radio-buttons"
                                id="radio-generic"
                                value="generic"
                                checked={!useCustomDomain}
                                onChange={handleGenericChange}
                            />
                        </div>
                        {useGenericDomain && (
                            <div className="row">
                                <div className="col-3">
                                    <Form.Group
                                        className="mb-3 row mr-1"
                                        controlId="exampleForm.ControlInput2"
                                    >
                                        <Form.Label>
                                            {language?.welcomepage?.subdomain ??
                                                "Subdomain"}
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            style={{
                                                color: "#778899",
                                                background: "#c0c0c0",
                                            }}
                                            value={cpi}
                                            disabled
                                        />
                                        {/* <Form.Control.Feedback type="invalid">{createErrorsCpi}</Form.Control.Feedback> */}
                                    </Form.Group>
                                </div>
                                <div className="col-9">
                                    <Form.Group
                                        className="mb-3 row"
                                        controlId="exampleForm.ControlInput2"
                                    >
                                        <Form.Label>
                                            {language?.welcomepage
                                                ?.website_domain ??
                                                "Website domain"}
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={genericDomain}
                                            style={{
                                                color: "#778899",
                                                background: "#c0c0c0",
                                            }}
                                            disabled
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        )}
                        <div className="row d-flex align-items-center">
                            <Form.Check
                                inline
                                type="radio"
                                label={
                                    language?.tracker_wizard
                                        ?.use_custom_domain ??
                                    "Use Custom Domain"
                                }
                                name="radio-buttons"
                                id="radio-custom"
                                value="custom"
                                checked={useCustomDomain}
                                onChange={handleCustomChange}
                            />
                            <OverlayTrigger
                                trigger={["hover", "focus"]}
                                placement="right"
                                overlay={CustomSubdomainPopover}
                                delay={{ show: 100, hide: 1500 }}
                            >
                                <InfoCircleFill
                                    style={{
                                        color: "cornflowerblue",
                                        fontSize: "small",
                                    }}
                                ></InfoCircleFill>
                            </OverlayTrigger>
                        </div>
                        {useCustomDomain && (
                            <div className="row">
                                <div className="col-3">
                                    <Form.Group
                                        className="mb-3 row mr-1"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <Form.Label>
                                            {language?.welcomepage?.subdomain ??
                                                "Subdomain"}
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={customCpi}
                                            onChange={handleCpi}
                                            isInvalid={!!createErrorsCpi}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {createErrorsCpi}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="col-9">
                                    <Form.Group
                                        className="mb-3 row"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <Form.Label>
                                            {language?.welcomepage
                                                ?.website_domain ??
                                                "Website domain"}
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={customDomain}
                                            isInvalid={!!createErrors}
                                            onChange={handleSubdomain}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {createErrors}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                            </div>
                        )}
                    </div>
                </Form.Group>
                <div className="row">
                    <Button
                        className=" btn-block mt-1"
                        style={{ backgroundColor: "#1877f2 " }}
                        onClick={handleCreateSource}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <ClipLoader color="#fff" size={18} />
                        ) : (
                            <>
                                <i className="i-Facebook-2 mr-2"></i>
                                {language?.source_modal
                                    ?.continue_with_facebook ??
                                    "Continue With Facebook"}
                            </>
                        )}
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default SourcesModal;
